import { DefaultService } from '@/services/DefaultService';

/**
 * @deprecated Essa classe foi depreciada e nao devera ser usada. 
 * Usar FaseFenologicaService ao inves.
 */
export default class FaseCultivoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    save(fasecultivo) {
        return this._http.post(`${this._env}/agro/fasedecultivo`, fasecultivo, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    find(id) {
        return this._http.get(`${this._env}/agro/fasedecultivo/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(column = 'descricao', order = 'asc', page = 0, limit = 50, situacao = 2, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/fasedecultivo.json?page=${page}&limit=${limit}&situacao=${situacao}&column=${column}&order=${order}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacao(fasecultivo) {
        return this._http.post(`${this._env}/agro/fasedecultivo/updatesituacao`, fasecultivo, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

}